import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { CurrencyInput } from 'ui-components/components/currency-input';
import { FlexRow } from 'ui-components/components/flex';

import FormattedCurrency from '../../../../../components/formatted-currency/container';
import { createColumnDefinitionBuilder } from '../../../../../components/items-table/create-column-definition-builder';
import { CurrencyPropType } from '../../../../../prop-types/currency';
import messages from '../messages';
import style from '../style.module.less';

const EditItemUnitPriceColumnId = 'edit-unit-price';
const UnitPricePropertyName = 'unitPrice';

const editItemUnitPriceDataBuilder = (item) => {
  return {
    id: item.id,
    unitPrice: item.unitPrice,
    readonly: item.readonly,
  };
};

const EditItemUnitPrice = ({ value: item, onColumnBlur, disabled = false }) => {
  const [price, setPrice] = useState(item.unitPrice.value);

  const onBlur = useCallback(
    (updatedValue) => {
      const parsedValue = Number.parseFloat(updatedValue);
      onColumnBlur(item.id, {
        [UnitPricePropertyName]: {
          code: item.unitPrice.code,
          value: parsedValue,
        },
      });
    },
    [item.id, item.unitPrice.code, onColumnBlur],
  );

  const onChange = useCallback(
    (updatedValue) => {
      setPrice(updatedValue);
    },
    [setPrice],
  );

  if (item.readonly?.code) {
    return (
      <FlexRow className={style['read-only-unit-price']}>
        <FormattedCurrency currencyCode={item.unitPrice.code} value={item.unitPrice.value} />
      </FlexRow>
    );
  }

  return (
    <CurrencyInput
      className={style['price-input']}
      currencyCode={item.unitPrice.code}
      disabled={disabled}
      onBlur={onBlur}
      onChange={onChange}
      showPlaceHolderForZero
      value={price}
    />
  );
};

EditItemUnitPrice.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string.isRequired,
    unitPrice: CurrencyPropType.isRequired,
    readonly: PropTypes.shape({
      code: PropTypes.string,
    }),
  }).isRequired,
  onColumnBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const createEditItemUnitColumnDefinition = createColumnDefinitionBuilder({
  header: <FormattedMessage {...messages.itemUnitPrice} />,
  accessor: EditItemUnitPriceColumnId,
  className: style['right-align-header'],
  cell: EditItemUnitPrice,
  width: 0.75,
});

export { EditItemUnitPriceColumnId, editItemUnitPriceDataBuilder, createEditItemUnitColumnDefinition, EditItemUnitPrice };
